export default "__VITE_ASSET__DMgF08cH__"